/* eslint-disable no-var */
var evs = require('eventsource-polyfill/dist/eventsource')
module.exports = window.EventSource || evs.EventSource



//////////////////
// WEBPACK FOOTER
// ./~/@sanity/eventsource/browser.js
// module id = 276
// module chunks = 0